import classNames from "classnames";
import React, { HTMLAttributes } from "react";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { TagClose, TagContent, TagWrapper } from "./Tag.styled";

export type TagProps = HTMLAttributes<HTMLDivElement> & {
  /**
   * Callback after close button has been clicked
   */
  onCloseClick?: () => void;

  /**
   * boolean for close button
   */
  hasCloseIcon?: boolean;
};

const defaultProps = {
  onCloseClick: () => {},
  hasCloseIcon: true
};

const Tag = React.forwardRef<HTMLDivElement, TagProps>((props, ref) => {
  const { children, className, onCloseClick, hasCloseIcon } = props;
  const tagClass = classNames("c-tag", className);

  return (
    <TagWrapper ref={ref} className={tagClass} data-testid="qa-tag">
      <TagContent data-testid="qa-tag-content">{children}</TagContent>
      {hasCloseIcon && (
        <TagClose data-testid="qa-tag-close-button" type="button" onClick={onCloseClick}>
          <FontAwesomeIcon icon={faTimes} />
        </TagClose>
      )}
    </TagWrapper>
  );
});

Tag.defaultProps = defaultProps;

export default Tag;
